<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('servAppraiseManage.queryTitle') }}</span>
          </div>
          <el-form :inline="true" :model="servAppraiseManageInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input
                v-model="servAppraiseManageInfo.conditions.servName"
                :placeholder="$t('servAppraiseManage.servNamePlaceholder')"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="servAppraiseManageInfo.conditions.appraiseUserName"
                :placeholder="$t('servAppraiseManage.userPlaceholder')"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="servAppraiseManageInfo.conditions.servId"
                :placeholder="$t('servAppraiseManage.servIdPlaceholder')"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="_queryOrdersMethod">
                <i class="el-icon-search"></i> {{ $t('servAppraiseManage.queryBtn') }}
              </el-button>
              <el-button size="small" @click="_resetOrdersMethod">
                <i class="el-icon-refresh"></i> {{ $t('servAppraiseManage.resetBtn') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('servAppraiseManage.tableTitle') }}</span>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="_openAddDialog">
              {{ $t('servAppraiseManage.addBtn') }}
            </el-button>
          </div>
          <serv-appraise-manage-table
            :appraises="servAppraiseManageInfo.appraises"
            @edit-appraise="_openEditDialog"
            @delete-appraise="_openDeleteDialog"
          />
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="servAppraiseManageInfo.total"
            :page-size="servAppraiseManageInfo.conditions.row"
            :current-page="servAppraiseManageInfo.conditions.page"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </el-card>
      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" @close="_resetForm">
      <el-form ref="appraiseForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item :label="$t('servAppraiseManage.form.servName')" prop="servName">
          <el-input v-model="form.servName" :placeholder="$t('servAppraiseManage.form.servNameRequired')" maxlength="30" clearable show-word-limit />
        </el-form-item>
        <el-form-item :label="$t('servAppraiseManage.form.userName')" prop="appraiseUserName">
          <el-input v-model="form.appraiseUserName" :placeholder="$t('servAppraiseManage.form.userNameRequired')" maxlength="30" />
        </el-form-item>
        <el-form-item :label="$t('servAppraiseManage.form.score')" prop="appraiseScore">
          <el-rate v-model="form.appraiseScore" :max="5" show-score />
        </el-form-item>
        <el-form-item label="物流评分">
          <el-rate v-model="form.logisticsScore" :max="5" show-score />
        </el-form-item>
        <el-form-item label="服务评分">
          <el-rate v-model="form.serviceScore" :max="5" show-score />
        </el-form-item>
        <el-form-item :label="$t('servAppraiseManage.form.context')" prop="context">
          <el-input
            v-model="form.context"
            type="textarea"
            :rows="4"
            :placeholder="$t('servAppraiseManage.form.contextRequired')"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <el-form-item :label="$t('servAppraiseManage.form.images')">
          <upload-image-url
            ref="appraiseImageUpload"
            :image-count="4"
            @notifyUploadCoverImage="handleAppraiseImageUpload"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="_submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import {
  queryShopAppraise,
  saveShopAppraise,
  updateShopAppraise,
  deleteShopAppraise
} from '@/api/housekeeping/servAppraiseManage/servAppraiseManageApi'
import ServAppraiseManageTable from '@/components/housekeeping/servAppraiseManage/servAppraiseManageTable'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  name: 'ServAppraiseManage',
  components: {
    ServAppraiseManageTable,
    UploadImageUrl
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      dialogVisible: false,
      isEdit: false,
      submitLoading: false,
      originalObjId: '',
      originalServName: '',
      servAppraiseManageInfo: {
        appraises: [],
        total: 0,
        conditions: {
          servName: '',
          servId: '',
          appraiseUserName: '',
          shopId: '',
          objType: '2002',
          page: 1,
          row: 10
        }
      },
      form: {
        appraiseId: '',
        shopId: '',
        servName: '',
        objId: '',
        objType: '2002',
        appraiseUserName: '',
        appraiseUserId: '-1',
        appraiseScore: 5,
        logisticsScore: 5,
        serviceScore: 5,
        context: '',
        imgPath: '',
        parentAppraiseId: '-1'
      },
      rules: {
        servName: [{ required: true, message: this.$t('servAppraiseManage.form.servNameRequired'), trigger: 'blur' }],
        appraiseUserName: [{ required: true, message: this.$t('servAppraiseManage.form.userNameRequired'), trigger: 'blur' }],
        appraiseScore: [{ required: true, message: this.$t('servAppraiseManage.form.scoreRequired'), trigger: 'change' }],
        context: [{ required: true, message: this.$t('servAppraiseManage.form.contextRequired'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? this.$t('servAppraiseManage.editTitle') : this.$t('servAppraiseManage.addTitle')
    }
  },
  created() {
    this.servAppraiseManageInfo.conditions.shopId = getShopId()
    this._listServAppraises(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    getImgList(imgPath) {
      if (!imgPath) {
        return []
      }
      return String(imgPath).split('|').filter(item => !!item)
    },
    handleAppraiseImageUpload(urls) {
      this.form.imgPath = (urls || []).filter(item => !!item).join('|')
    },
    _listServAppraises(_page, _rows) {
      this.servAppraiseManageInfo.conditions.page = _page
      this.servAppraiseManageInfo.conditions.row = _rows
      const params = {
        ...this.servAppraiseManageInfo.conditions,
        servName: (this.servAppraiseManageInfo.conditions.servName || '').trim(),
        appraiseUserName: (this.servAppraiseManageInfo.conditions.appraiseUserName || '').trim(),
        servId: (this.servAppraiseManageInfo.conditions.servId || '').trim()
      }

      queryShopAppraise(params)
        .then(response => {
          this.servAppraiseManageInfo.total = response.total || 0
          this.servAppraiseManageInfo.records = response.records
          this.servAppraiseManageInfo.appraises = response.data || []
        })
        .catch(error => {
          console.log('请求失败处理', error)
          this.$message.error('查询评价失败')
        })
    },
    _queryOrdersMethod() {
      this._listServAppraises(this.DEFAULT_PAGE, this.servAppraiseManageInfo.conditions.row)
    },
    _resetOrdersMethod() {
      this.servAppraiseManageInfo.conditions.servName = ''
      this.servAppraiseManageInfo.conditions.appraiseUserName = ''
      this.servAppraiseManageInfo.conditions.servId = ''
      this._listServAppraises(this.DEFAULT_PAGE, this.servAppraiseManageInfo.conditions.row)
    },
    _openAddDialog() {
      this.isEdit = false
      this.originalObjId = ''
      this.originalServName = ''
      this._resetForm()
      this.form.shopId = getShopId()
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.appraiseImageUpload) {
          this.$refs.appraiseImageUpload.clearImages()
        }
      })
    },
    _openEditDialog(row) {
      this.isEdit = true
      const servName = row.servName || row.prodName || row.objId || ''
      this.originalObjId = row.objId || ''
      this.originalServName = servName
      this.form = {
        appraiseId: row.appraiseId,
        shopId: row.shopId || getShopId(),
        servName,
        objId: row.objId,
        objType: row.objType || '2002',
        appraiseUserName: row.appraiseUserName,
        appraiseUserId: row.appraiseUserId || '-1',
        appraiseScore: Number(row.appraiseScore) || 5,
        logisticsScore: Number(row.logisticsScore) || Number(row.appraiseScore) || 5,
        serviceScore: Number(row.serviceScore) || Number(row.appraiseScore) || 5,
        context: row.context || '',
        imgPath: row.imgPath || '',
        parentAppraiseId: row.parentAppraiseId || '-1'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.appraiseImageUpload) {
          this.$refs.appraiseImageUpload.setImages(this.getImgList(row.imgPath))
        }
      })
    },
    _openDeleteDialog(row) {
      this.$confirm(this.$t('servAppraiseManage.deleteConfirm'), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteShopAppraise({
            appraiseId: row.appraiseId,
            shopId: row.shopId || getShopId()
          })
          this.$message.success('删除成功')
          this._listServAppraises(
            this.servAppraiseManageInfo.conditions.page,
            this.servAppraiseManageInfo.conditions.row
          )
        } catch (error) {
          this.$message.error(typeof error === 'string' ? error : '删除失败')
        }
      }).catch(() => {})
    },
    _resetForm() {
      this.form = {
        appraiseId: '',
        shopId: getShopId(),
        servName: '',
        objId: '',
        objType: '2002',
        appraiseUserName: '',
        appraiseUserId: '-1',
        appraiseScore: 5,
        logisticsScore: 5,
        serviceScore: 5,
        context: '',
        imgPath: '',
        parentAppraiseId: '-1'
      }
      if (this.$refs.appraiseForm) {
        this.$refs.appraiseForm.clearValidate()
      }
      if (this.$refs.appraiseImageUpload) {
        this.$refs.appraiseImageUpload.clearImages()
      }
    },
    _submitForm() {
      this.$refs.appraiseForm.validate(async valid => {
        if (!valid) {
          return
        }
        if (!this.form.appraiseScore || this.form.appraiseScore < 1) {
          this.$message.warning(this.$t('servAppraiseManage.form.scoreRequired'))
          return
        }
        const servName = (this.form.servName || '').trim()
        // 新增：服务名称自由填写，写入 objId；编辑且名称未变时保留原 objId（兼容真实服务ID）
        let objId = servName
        if (this.isEdit && servName === this.originalServName && this.originalObjId) {
          objId = this.originalObjId
        }
        this.submitLoading = true
        const payload = {
          ...this.form,
          shopId: this.form.shopId || getShopId(),
          objType: '2002',
          objId,
          appraiseScore: String(this.form.appraiseScore),
          logisticsScore: String(this.form.logisticsScore || this.form.appraiseScore),
          serviceScore: String(this.form.serviceScore || this.form.appraiseScore),
          imgPath: this.form.imgPath || ''
        }
        try {
          if (this.isEdit) {
            await updateShopAppraise(payload)
            this.$message.success('修改成功')
          } else {
            await saveShopAppraise(payload)
            this.$message.success('新增成功')
          }
      this.dialogVisible = false
          // dialog @close 会重置表单，这里先记下是否编辑再刷新列表
          const stayPage = this.isEdit
          this._listServAppraises(
            stayPage ? this.servAppraiseManageInfo.conditions.page : this.DEFAULT_PAGE,
            this.servAppraiseManageInfo.conditions.row
          )
        } catch (error) {
          this.$message.error(typeof error === 'string' ? error : (this.isEdit ? '修改失败' : '新增失败'))
        } finally {
          this.submitLoading = false
        }
      })
    },
    handleCurrentChange(val) {
      this._listServAppraises(val, this.servAppraiseManageInfo.conditions.row)
    },
    handleSizeChange(val) {
      this.servAppraiseManageInfo.conditions.row = val
      this._listServAppraises(this.DEFAULT_PAGE, val)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.el-row {
  width: 100%;
}

.el-col {
  width: 100%;
}
</style>
